export default {
    ROUTE: {
        ROOT: `/`,
        LOGIN: `/Login`,
        CUSTOMERS: `/Customers`,
        VEHICLES: `/Vehicles`,
        FORBIDDEN: `/Forbidden`
    },
    CUSTOMERS: {
        DISPLAY: {
            ORDERS: `orders`,
            DETAILS: `details`,
            VEHICLES: `vehicles`,
            PREFERRED_DEALER: `preferreddealer`
        }
    },
    STATUS_CODE: {
        BAD_REQUEST: 400,
        UNAUTHORIZED: 401,
        FORBIDDEN: 403,
        NOT_FOUND: 404,
        OK: 200,
        CREATED: 201,
        ACCEPTED: 202,
        NO_CONTENT: 204
    },
    PROLONGED_ACTION_STATUS: {
        PENDING: 100
    },
    BRANDS: {
        LEXUS: `LEXUS`,
        TOYOTA: `TOYOTA`,
        SUBARU: `SUBARU`
    },
    REQUIRED_ROLE: [`CPADMIN NMSC User`, `CPADMIN TME User`]
};
